export default {
    //tool.js
    addWaterMark() {
        const str1 = `${localStorage.getItem(
            "loginUserName"
        )}`;
        const str2 = `${localStorage.getItem(
            "loginUserPhone"
        )}`;
        let ctx = document.createElement("canvas");
        ctx.width = 280;
        ctx.height = 200;
        ctx.style.display = "none";
        let cans = ctx.getContext("2d");
        cans.rotate((-15 * Math.PI) / 180);
        cans.font = "16px Microsoft YaHei";
        cans.fillStyle = "rgba(17, 17, 17, 0.30)";
        cans.textAlign = "center";
        cans.textBaseline = "Middle";
        cans.fillText(str1, 180, 100, 120);
        cans.fillText(str2, 180, 120, 120);
        cans.save();
        return ctx.toDataURL();
    }
}



// WEBPACK FOOTER //
// ./src/util/waterMark.js